namespace pixi_spine {
    (PIXI as any).spine = pixi_spine;
}
